import React, {useState} from 'react';
import {LogInState, Role} from "./Utils/enums";
import {LoggedInContext} from './Utils/contexts'
import Login from './Screens/UnauthorizedScreens/LogInScreen';
import Welcome from './Screens/UnauthorizedScreens/WelcomeScreen';
import Home from './Screens/HomeScreen/Home';
import {Route, Routes, Navigate, useLocation} from "react-router-dom";

const App: React.FC = () => {
    const [isLoggedIn, setLoggedIn] = useState(LogInState.AppLoading);
    const [role, setRole] = useState<Role>(Role.Unknown);
    const [myUserId, setMyUserId] = useState<number>(0);
    const location = useLocation();

    return (
          <LoggedInContext.Provider value={setLoggedIn}>
            <Routes>
              {isLoggedIn === LogInState.AppLoading? <Route path="/*" element={<Welcome setRole={setRole} setMyUserId={setMyUserId} />} /> : <></>}
              {isLoggedIn === LogInState.LoggedIn? <Route path="/*" element={<Home role={role} setRole={setRole} myUserId={myUserId} setMyUserId={setMyUserId}/>} /> : <></>}
              {isLoggedIn === LogInState.NotLoggedIn? <Route path="/login" element={<Login setRole={setRole} setUserId={setMyUserId}/>} /> : <></>}
                <Route path="*" element={<Navigate to={
                    isLoggedIn === LogInState.NotLoggedIn? `/login?redirect=${encodeURIComponent(location.pathname+location.search)}` :
                    '/'
                } />
              }/>
            </Routes>
          </LoggedInContext.Provider>
  );
};

export default App;
